namespace SP {
    let _zoom = 1;
    
    export function formatNumber(amount: number = null, decimals: number = 2, locale: string = 'en-US', style: string = 'decimal') {
        // Create a new instance of Intl.NumberFormat
        const formatter = new Intl.NumberFormat(locale, {
            style: style, // This is for normal number formatting, not currency
            minimumFractionDigits: decimals, // Ensures two digits after the decimal
            maximumFractionDigits: decimals, // Ensures no more than two digits after the decimal
        });

        // Use the format method of the formatter to format your number
        return formatter.format(amount);
    }
}